export default __webpack_public_path__ + "static/media/apple.ab0975ea.svg";